import type { TranslationMessages } from "ra-core";

/**
 * Complete Dutch catalog for ra-core / shadcn-admin-kit.
 * Typed as TranslationMessages so a missing framework key fails typecheck.
 */
export const dutchRaMessages = {
  ra: {
    action: {
      add_filter: "Filter toevoegen",
      add: "Toevoegen",
      back: "Ga terug",
      bulk_actions:
        "1 item geselecteerd |||| %{smart_count} items geselecteerd",
      cancel: "Annuleren",
      clear_array_input: "Lijst wissen",
      clear_input_value: "Waarde wissen",
      clear_search: "Zoekopdracht wissen",
      clone: "Klonen",
      close: "Sluiten",
      close_menu: "Menu sluiten",
      confirm: "Bevestigen",
      create: "Aanmaken",
      create_item: "%{item} aanmaken",
      delete: "Verwijderen",
      edit: "Bewerken",
      expand: "Uitklappen",
      export: "Exporteren",
      list: "Lijst",
      move_down: "Omlaag",
      move_up: "Omhoog",
      open: "Openen",
      open_menu: "Menu openen",
      refresh: "Verversen",
      remove: "Verwijderen",
      remove_all_filters: "Alle filters verwijderen",
      remove_filter: "Deze filter verwijderen",
      reset: "Resetten",
      save: "Opslaan",
      search: "Zoeken",
      search_columns: "Kolommen zoeken",
      select_all: "Alles selecteren",
      select_all_button: "Alles selecteren",
      select_columns: "Kolommen",
      select_row: "Deze rij selecteren",
      show: "Tonen",
      sort: "Sorteren",
      toggle_theme: "Lichte/donkere modus",
      undo: "Ongedaan maken",
      unselect: "Deselecteren",
      update: "Bijwerken",
      update_application: "Applicatie herladen",
    },
    boolean: {
      true: "Ja",
      false: "Nee",
      null: "\u2003",
    },
    page: {
      create: "%{name} aanmaken",
      dashboard: "Dashboard",
      edit: "%{name} %{recordRepresentation}",
      error: "Er ging iets mis",
      list: "%{name}",
      loading: "Laden",
      not_found: "Niet gevonden",
      show: "%{name} %{recordRepresentation}",
      empty: "Nog geen %{name}.",
      invite: "Wil je er een toevoegen?",
      access_denied: "Geen toegang",
      authentication_error: "Authenticatiefout",
    },
    input: {
      file: {
        upload_several:
          "Sleep bestanden hierheen of klik om er een te selecteren.",
        upload_single:
          "Sleep een bestand hierheen of klik om het te selecteren.",
      },
      image: {
        upload_several:
          "Sleep afbeeldingen hierheen of klik om er een te selecteren.",
        upload_single:
          "Sleep een afbeelding hierheen of klik om die te selecteren.",
      },
      password: {
        toggle_visible: "Wachtwoord verbergen",
        toggle_hidden: "Wachtwoord tonen",
      },
      references: {
        all_missing: "Kan de gekoppelde gegevens niet vinden.",
        many_missing:
          "Minstens een van de gekoppelde verwijzingen lijkt niet meer beschikbaar.",
        single_missing: "De gekoppelde verwijzing lijkt niet meer beschikbaar.",
      },
    },
    message: {
      about: "Over",
      access_denied: "Je hebt geen rechten om deze pagina te openen",
      are_you_sure: "Weet je het zeker?",
      authentication_error:
        "De authenticatieserver gaf een fout en je gegevens konden niet worden gecontroleerd.",
      auth_error:
        "Er ging iets mis bij het controleren van het authenticatietoken.",
      bulk_delete_content:
        "Weet je zeker dat je deze %{name} wilt verwijderen? |||| Weet je zeker dat je deze %{smart_count} items wilt verwijderen?",
      bulk_delete_title:
        "%{name} verwijderen |||| %{smart_count} %{name} verwijderen",
      bulk_update_content:
        "Weet je zeker dat je %{name} %{recordRepresentation} wilt bijwerken? |||| Weet je zeker dat je deze %{smart_count} items wilt bijwerken?",
      bulk_update_title:
        "%{name} %{recordRepresentation} bijwerken |||| %{smart_count} %{name} bijwerken",
      clear_array_input: "Weet je zeker dat je de hele lijst wilt wissen?",
      delete_content: "Weet je zeker dat je deze %{name} wilt verwijderen?",
      delete_title: "%{name} %{recordRepresentation} verwijderen",
      details: "Details",
      error:
        "Er is een fout opgetreden en je verzoek kon niet worden afgerond.",
      invalid_form: "Het formulier is niet geldig. Controleer de fouten",
      loading: "Even geduld",
      no: "Nee",
      not_found:
        "Je hebt een verkeerde URL ingetypt of een ongeldige link gevolgd.",
      placeholder_data_warning:
        "Netwerkprobleem: gegevens vernieuwen is mislukt.",
      select_all_limit_reached:
        "Er zijn te veel elementen om alles te selecteren. Alleen de eerste %{max} elementen zijn geselecteerd.",
      unsaved_changes:
        "Een deel van je wijzigingen is niet opgeslagen. Weet je zeker dat je ze wilt negeren?",
      yes: "Ja",
    },
    navigation: {
      breadcrumb_drawer_instructions: "Kies een pagina om naartoe te gaan.",
      breadcrumb_drawer_title: "Navigeren naar",
      clear_filters: "Filters wissen",
      current_page: "Pagina %{page}",
      first: "Ga naar de eerste pagina",
      last: "Ga naar de laatste pagina",
      next: "Ga naar de volgende pagina",
      no_filtered_results: "Geen %{name} gevonden met de huidige filters.",
      no_more_results:
        "Paginanummer %{page} bestaat niet. Probeer de vorige pagina.",
      no_results: "Geen %{name} gevonden",
      page: "Ga naar pagina %{page}",
      page_out_from_begin: "Je kunt niet vóór pagina 1 gaan",
      page_out_from_end: "Je kunt niet voorbij de laatste pagina gaan",
      page_out_of_boundaries: "Paginanummer %{page} valt buiten het bereik",
      page_range_info: "%{offsetBegin}-%{offsetEnd} van %{total}",
      page_rows_per_page: "Rijen per pagina:",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} van meer dan %{offsetEnd}",
      previous: "Ga naar de vorige pagina",
      skip_nav: "Ga naar de inhoud",
    },
    sort: {
      sort_by: "Sorteren op %{field_lower_first} %{order}",
      ASC: "oplopend",
      DESC: "aflopend",
    },
    auth: {
      auth_check_error: "Log in om verder te gaan",
      create_account: "Account aanmaken",
      email: "E-mail",
      logout: "Uitloggen",
      password: "Wachtwoord",
      sign_in: "Inloggen",
      sign_in_error: "Inloggen mislukt, probeer het opnieuw",
      user_menu: "Profiel",
      username: "Gebruikersnaam",
    },
    notification: {
      updated: "Element bijgewerkt |||| %{smart_count} elementen bijgewerkt",
      created: "Element aangemaakt",
      deleted: "Element verwijderd |||| %{smart_count} elementen verwijderd",
      bad_item: "Onjuist element",
      item_doesnt_exist: "Element bestaat niet",
      http_error: "Fout bij de communicatie met de server",
      data_provider_error:
        "Fout in de dataProvider. Bekijk de console voor details.",
      i18n_error: "De vertalingen voor deze taal kunnen niet worden geladen",
      canceled: "Actie geannuleerd",
      logged_out: "Je sessie is afgelopen, log opnieuw in.",
      not_authorized: "Je hebt geen toegang tot deze gegevens.",
      application_update_available: "Er is een nieuwe versie beschikbaar.",
      offline: "Geen verbinding. Gegevens konden niet worden opgehaald.",
    },
    validation: {
      required: "Verplicht",
      minLength: "Minimaal %{min} tekens",
      maxLength: "Maximaal %{max} tekens",
      minValue: "Moet minstens %{min} zijn",
      maxValue: "Mag hoogstens %{max} zijn",
      number: "Moet een getal zijn",
      email: "Moet een geldig e-mailadres zijn",
      oneOf: "Moet een van de volgende zijn: %{options}",
      regex: "Moet voldoen aan een specifiek formaat (regexp): %{pattern}",
      unique: "Moet uniek zijn",
    },
    saved_queries: {
      label: "Opgeslagen zoekopdrachten",
      query_name: "Naam van de zoekopdracht",
      new_label: "Huidige zoekopdracht opslaan...",
      new_dialog_title: "Huidige zoekopdracht opslaan als",
      remove_label: "Opgeslagen zoekopdracht verwijderen",
      remove_label_with_name: 'Zoekopdracht "%{name}" verwijderen',
      remove_dialog_title: "Opgeslagen zoekopdracht verwijderen?",
      remove_message:
        "Weet je zeker dat je dit item uit je opgeslagen zoekopdrachten wilt halen?",
      help: "Filter de lijst en bewaar deze zoekopdracht voor later",
    },
    guesser: {
      empty: {
        title: "Geen gegevens om te tonen",
        message: "Controleer je dataProvider",
      },
    },
    configurable: {
      customize: "Aanpassen",
      configureMode: "Deze pagina configureren",
      inspector: {
        title: "Inspector",
        content: "Wijs UI-elementen aan om ze te configureren",
        reset: "Instellingen resetten",
        hideAll: "Alles verbergen",
        showAll: "Alles tonen",
      },
      Datagrid: {
        title: "Tabel",
        unlabeled: "Kolom zonder label #%{column}",
      },
      SimpleForm: {
        title: "Formulier",
        unlabeled: "Veld zonder label #%{input}",
      },
      SimpleList: {
        title: "Lijst",
        primaryText: "Primaire tekst",
        secondaryText: "Secundaire tekst",
        tertiaryText: "Tertiaire tekst",
      },
    },
  },
} satisfies TranslationMessages;
